import React from 'react';
import { IComparisonToolWidgetProps } from './comparison-tool.models';
import { ChevronIcon, Chip, GridItemLayout, GridLayout, useMatchScreenWidth } from '@keplerco/core';
import { RoleComparisonIcon } from '../../../pages/analytics/comparison-tools/role-comparison/role-comparison.icon';
import { PeopleComparisonIcon } from '../../../pages/analytics/comparison-tools/people-comparison/people-comparison.icon';
import classNames from 'classnames';
import styles from './comparison-tool.module.css';
import { WidgetCard } from '../../../pages/analytics/analytics-filters/widget-card';

export function ComparisonToolWidget({ title, primaryCondition, secondaryCondition }: IComparisonToolWidgetProps): JSX.Element {
  const isMobile = useMatchScreenWidth('mobile');

  return (
    <React.Fragment>
      <WidgetCard title={title}>
        <GridLayout columnCount={isMobile ? 1 : 2}>
          <GridItemLayout>
            <button className={classNames('card', styles.conditionButton)} onClick={() => primaryCondition.onClick()}>
              <RoleComparisonIcon tone="baby-blue" />
              <div>
                <h4 className={styles.heading}>
                  {primaryCondition.title}
                  {!!primaryCondition.chipLabel ? <Chip customTheme={{ backgroundColor: 'background', borderColor: 'baby-blue', color: 'text' }}>{primaryCondition.chipLabel}</Chip> : <Chip customTheme={{ backgroundColor: 'background', borderColor: 'borders', color: 'text' }}>Nothing selected</Chip>}
                </h4>

                <small className={classNames(styles.caption)}>{primaryCondition.subtitle}</small>
              </div>
              <div style={{ marginLeft: 'auto' }}>
                <ChevronIcon tone="primary" size={25} />
              </div>
            </button>
          </GridItemLayout>

          <GridItemLayout>
            <button className={classNames('card', styles.conditionButton)} disabled={!primaryCondition.chipLabel} onClick={() => secondaryCondition.onClick()}>
              <PeopleComparisonIcon tone={primaryCondition.chipLabel ? 'grape' : 'default'} />
              <div>
                <h4 className={styles.heading}>
                  {secondaryCondition.title}
                  {!!secondaryCondition.chipLabel ? <Chip customTheme={{ backgroundColor: 'background', borderColor: 'grape', color: 'text' }}>{secondaryCondition.chipLabel}</Chip> : <Chip customTheme={{ backgroundColor: 'background', borderColor: 'borders', color: 'text' }}>Nothing selected</Chip>}
                </h4>

                <small className={styles.caption}>{secondaryCondition.subtitle}</small>
              </div>
              <div style={{ marginLeft: 'auto' }}>
                <ChevronIcon tone={primaryCondition.chipLabel ? 'primary' : 'default'} size={25} />
              </div>
            </button>
          </GridItemLayout>
        </GridLayout>
      </WidgetCard>

      {primaryCondition.panel}

      {secondaryCondition.panel}
    </React.Fragment>
  );
}
